import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobDocument.Delete.IRequest;
type Response = Api.Core.ClaimJobDocument.Delete.IResponse;
type Headers = Api.Core.ClaimJobDocument.Delete.IHeaders;
const url = '/api/Claims/ClaimJob/:claimJobId/Documents/:documentId';
export default async function claimJobDocumentDeleteApi(params: {
  claimJobId: number;
  documentId: number;
}): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
